import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { navigate } from 'gatsby';

import Wrapper from '../../elements/wrapper';
import { media, TransitionMixin } from '../../helpers';

const BrandedFormContainer = styled.div`
    padding: 100px 0 0;
    position: relative;
    z-index: 150;

    .title-container {
        text-align: center;
        margin-bottom: 40px;
        h3 {
            font-size: 2rem;
            color: #000;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            margin: 0 0 10px;
        }

        p {
            font-size: 0.9rem;
            margin: 0;
        }
    }
    .form-container {
        max-width: 450px;
        margin: 0 auto;
        text-align: center;

        .input-row {
            text-align: left;
            margin-bottom: 20px;
            &.split {
                display: flex;

                .input-container {
                    &:first-child {
                        margin-right: 15px;
                    }
                }
            }
            &.deadline {
                margin-bottom: 40px;
                .input-container {
                    display: flex;
                    align-items: center;
                    label {
                        margin-right: 20px;
                        font-size: 21px;
                        font-weight: bold;
                        flex: 0 0 40%;
                    }

                    input {
                        flex: 1;
                    }
                }
            }
            &.submit {
                .input-container {
                    display: block;
                }
            }

            .input-container {
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                > * {
                    flex: 1 1 100%;
                }
                label {
                    display: block;
                    font-weight: bold;
                    margin-bottom: 5px;
                    color: #000;
                    font-size: 0.8rem;
                }

                input {
                    background-color: #f2f0eb;
                    border: 1px solid #f2f0eb;
                    padding: 5px 0 5px 10px;
                    border-radius: 5px;
                }

                button {
                    background-color: #f74c34;
                    color: #fff;
                    font-weight: bold;
                    border-radius: 5px;
                    display: inline-block;
                    padding: 15px 20px;
                    border: 1px solid #f74c34;
                    font-family: neue-kabel, sans-serif;
                    font-weight: 800;
                    min-width: 185px;
                    ${TransitionMixin('.25s')};

                    &:hover {
                        background-color: #fff;
                        color: #f74c34;
                    }
                }
            }
        }

        h4 {
            padding-top: 20px;
            font-size: 1.1rem;
            color: #000;
        }
        .form-buttons-container {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 20px;

            .btn-container {
                flex: 0 0 33.33%;
                margin-bottom: 20px;

                button {
                    background-color: #f2f0eb;
                    border: 3px solid #f2f0eb;
                    border-radius: 4px;
                    display: inline-block;
                    padding: 5px 10px;
                    border-radius: 20px;
                    font-weight: bold;
                    min-width: 130px;
                    font-size: 0.8rem;

                    &:hover,
                    &.active {
                        background-color: #f74c34;
                        border-color: #f74c34;
                        color: #fff;
                    }

                    &:focus,
                    &:active {
                        outline: 0;
                    }
                }
            }
        }
    }
`;

const formButtons = [
    {
        title: 'Ties',
    },
    {
        title: 'Chiffon Scarves',
    },
    {
        title: 'Neck Gaiters',
    },
    {
        title: 'Bow Ties',
    },
    {
        title: 'Infinity Scarves',
    },
    {
        title: 'Pocket Squares',
    },
];

const BrandedForm = () => {
    const [date, setDate] = useState();
    const [maxDate, setMaxDate] = useState();
    const [formFields, setFormFields] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        company: '',
        interested_in: [],
        deadline: '',
    });

    function handleDateChange(e) {
        setFormFields({
            ...formFields,
            [e.target.name]: e.target.value,
        });
    }

    function getDate() {
        let dateObject = new Date();
        let day = dateObject.getDate();
        let month = dateObject.getUTCMonth() + 1;
        let year = dateObject.getUTCFullYear();

        let dateString = year + '-' + month + '-' + day;
        let maxDateString = year + 1 + '-' + month + '-' + day;

        setDate(dateString);
        setMaxDate(maxDateString);
    }

    function handleInputChange(e) {
        setFormFields({
            ...formFields,
            [e.target.name]: e.target.value,
        });
    }

    function handleButtonClick(e, title) {
        e.preventDefault();

        let hasButtonBeenSelected =
            formFields.interested_in.filter((item) => item === title).length >
            0;

        if (hasButtonBeenSelected) {
            // remove
            let newArray = formFields.interested_in;
            newArray = newArray.filter((item) => item !== title);
            setFormFields({
                ...formFields,
                interested_in: newArray,
            });
        } else {
            // add
            let newArray = formFields.interested_in;
            newArray.push(title);
            setFormFields({
                ...formFields,
                interested_in: newArray,
            });
        }
    }

    function handleFormSubmit(e) {
        e.preventDefault();
        // TODO: send info to Klaviyo

        navigate('/branded/step-1');
    }

    useEffect(() => {
        getDate();
    }, []);

    return (
        <BrandedFormContainer>
            <Wrapper className="title-container">
                <h3>What products do you want to customize?</h3>
                <p>
                    Contact our sales team and we’ll be back in touch as soon as
                    we can.
                </p>
            </Wrapper>
            <div className="form-container">
                <form>
                    <div className="input-row split">
                        <div className="input-container">
                            <label htmlFor="first_name">First Name</label>
                            <input
                                type="text"
                                name="first_name"
                                value={formFields['first_name']}
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>
                        <div className="input-container">
                            <label htmlFor="last_name">Last Name</label>
                            <input
                                type="text"
                                name="last_name"
                                value={formFields['last_name']}
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>
                    </div>
                    <div className="input-row">
                        <div className="input-container">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formFields['email']}
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>
                    </div>
                    <div className="input-row split">
                        <div className="input-container">
                            <label htmlFor="phone">Phone</label>
                            <input
                                type="text"
                                name="phone"
                                value={formFields['phone']}
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>
                        <div className="input-container">
                            <label htmlFor="company">Company</label>
                            <input
                                type="text"
                                name="company"
                                value={formFields['company']}
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>
                    </div>

                    <h4>What kind of products do you want to brand?</h4>

                    <div className="form-buttons-container">
                        {formButtons &&
                            formButtons.map((button) => {
                                let isButtonActive =
                                    formFields.interested_in.filter(
                                        (item) => item === button.title
                                    ).length > 0;

                                return (
                                    <div className="btn-container">
                                        <button
                                            className={
                                                isButtonActive ? 'active' : ''
                                            }
                                            onClick={(e) =>
                                                handleButtonClick(
                                                    e,
                                                    button.title
                                                )
                                            }
                                        >
                                            {button.title}
                                        </button>
                                    </div>
                                );
                            })}
                    </div>

                    <div className="input-row deadline">
                        <div className="input-container">
                            <label htmlFor="deadline">In-hand Deadline</label>
                            <input
                                type="date"
                                id="deadline"
                                name="deadline"
                                value={formFields.deadline}
                                min={date}
                                max={maxDate}
                                onChange={(e) => handleDateChange(e)}
                            />
                        </div>
                    </div>

                    <div className="input-row submit">
                        <div className="input-container">
                            <button
                                type="submit"
                                onClick={(e) => handleFormSubmit(e)}
                            >
                                Start Designing
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </BrandedFormContainer>
    );
};

export default BrandedForm;
